module.exports = __webpack_public_path__ + "assets/img/title2@2x.77ee8c10.png";